import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light text-dark py-4 mt-5">
      <div className="container text-center">
        <div className="row">
          <div className="col-md-6 mb-3">
            <h5>About Us</h5>
            <p>OPURL.cc provides a secure platform for temporary file uploads and seamless file sharing with top insights.</p>
          </div>
          <div className="col-md-6 mb-3">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-dark">Home</a></li>
              {/* <li><a href="#" className="text-dark">Upload File</a></li>
              <li><a href="#" className="text-dark">Security Insights</a></li>
              <li><a href="#" className="text-dark">Contact</a></li> */}
            </ul>
          </div>
          {/* <div className="col-md-4 mb-3">
            <h5>Follow Us</h5>
            <a href="#" className="text-dark me-2"><i className="fab fa-facebook"></i></a>
            <a href="#" className="text-dark me-2"><i className="fab fa-twitter"></i></a>
            <a href="#" className="text-dark"><i className="fab fa-linkedin"></i></a>
          </div> */}
        </div>
        <hr className="bg-dark" />
        <p className="mb-0">&copy; {new Date().getFullYear()} OPURL.cc. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
